<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          v-for="(item, i) in filteredCategories"
          :key="i"
          class="py-6 px-md-6"
          cols="12"
          md="6"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catBusinessShop",

  components: { CatCard },

  data: () => ({
    serviceName: "Qrland",
    componentName: "catBusinessShop",
    helpData: [],
  }),
  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  computed: {
    categories() {
      return [
        {
          name: this.$t("categories.personal_company_website"),
          value: "",
          route: "qr.bPage",
          colors: ["#3674B5", "#A1E3F9", "#578FCA"],
          icon: "mdi-store",
        },
        {
          name: this.$t("categories.online_store"),
          value: "",
          route: "qr.bShop",
          colors: ["#3A0519", "#A53860", "#670D2F"],
          icon: "mdi-storefront",
        },
        {
          name: this.$t("categories.online_menu"),
          value: "",
          route: "qr.menu",
          colors: ["#3E3232", "#7E6363", "#503C3C"],
          icon: "mdi-silverware",
          testTxt: this.$t("categories.version_three"),
        },
        {
          name: this.$t("categories.appointment_booking"),
          value: "",
          route: "qr.appointment",
          colors: ["#7E6363", "#9B86BD", "#7776B3"],
          icon: "mdi-calendar-month",
        },
        {
          name: this.$t("categories.commercial_admin_website"),
          value: "",
          route: "qr.cPage",
          colors: ["#006A71", "#9ACBD0", "#48A6A7"],
          icon: "mdi-office-building",
          isTest: false,
        },
        {
          name: this.$t("categories.online_insurance_sales"),
          value: "",
          route: "qr.insurance",
          colors: ["#8C0000", "#BD2000", "#FA1E0E"],
          icon: "mdi-shield-account-outline",
          comingSoon: true,
        },
        {
          name: this.$t("categories.discount_code"),
          value: "",
          route: "qr.link",
          colors: ["#FF8008", "#FFC837", "#FF8008"],
          icon: "mdi-sale",
          comingSoon: true,
        },
        {
          // name: this.$t("categories.discount_code"),
          name: "مولتی کارت",
          value: "",
          route: "qr.card",
          colors: ["#21ff08", "#7df661", "#21ff08"],
          icon: "mdi-credit-card-multiple",
          comingSoon: false,
        },
      ];
    },
    filteredCategories() {
      const currentLocale = this.$i18n.locale;
      if (currentLocale === "fa") {
        return this.categories;
      }
      return this.categories.map((x) => ({
        ...x,
        comingSoon:
          x.name !== this.$t("categories.online_store") &&
          x.route !== "qr.menu",
      }));
      // return this.categories.filter(
      // (item) => item.name === this.$t("categories.online_store")
      // );
    },
    combinedStyles() {
      const styles = {
        position: "absolute",
        bottom: "0%",
        paddingTop: "40px !important",
      };

      // Responsive left positioning
      styles.left = this.$vuetify.breakpoint.mobile ? "20%" : "7%";

      // Coming soon styles
      if (this.item.comingSoon) {
        styles.opacity = "0.2";
        styles.pointerEvents = "none";
      }

      return styles;
    },
  },
};
</script>

<style scoped></style>
